import { createTrendsTypes } from '../../common/trends/types';

export const NAMESPACE = 'analytics-trends-vdc';
export default createTrendsTypes(NAMESPACE);
